import { AvailableLinks, OilData, VibrationData } from 'queries/externalReferences/contract';

export const mockAvailableLinks: AvailableLinks = {
  links: [
    { SAP_NOTES: '' },
    { MAINTENANCE_PLAN: '' },
    { OIL_ANALYSIS: '' },
    { VIBRATION_ANALYSIS: '' },
  ],
};

export const mockOilData: OilData[] = [
  {
    'CBA-2430A-4S': 'Particle Coun PC > 4 por ml',
    '2022-09-16': '19',
    '2022-10-14': '',
    '2022-11-18': '17',
    '2023-01-20': '19',
    '2023-02-23': '18',
    '2023-03-25': '17',
    '2023-04-14': '17',
    '2023-05-17': '17',
    '2023-06-23': '17',
    '2023-07-19': '17',
    '2023-08-28': '17',
    '2023-09-15': '17',
    '2023-10-15': '18',
  },
  {
    'CBA-2430A-5S': 'Particle Coun PC > 6 por ml',
    '2022-09-16': '16',
    '2022-10-14': '',
    '2022-11-18': '13',
    '2023-01-20': '17',
    '2023-02-23': '16',
    '2023-03-25': '13',
    '2023-04-14': '13',
    '2023-05-17': '13',
    '2023-06-23': '15',
    '2023-07-19': '13',
    '2023-08-28': '14',
    '2023-09-15': '14',
    '2023-10-15': '16',
  },
  {
    'CBA-2430A-5S': 'Particle Coun PC > 6 por ml',
    '2022-09-16': '16',
    '2022-10-14': '',
    '2022-11-18': '13',
    '2023-01-20': '17',
    '2023-02-23': '16',
    '2023-03-25': '13',
    '2023-04-14': '13',
    '2023-05-17': '13',
    '2023-06-23': '15',
    '2023-07-19': '13',
    '2023-08-28': '14',
    '2023-09-15': '14',
    '2023-10-15': '16',
  },
];
export const mockVibrationData: VibrationData[] = [
  {
    tag: 'PBE-2472A-01-4S',
    technique: 'VIBRATION',
    diagnosis: null,
    status: 'Normal',
    observation:
      'Equipamento em condição normal em relação a vibração.\r\nEquipment in normal condition with respect to vibration level.',
    month: 'Sep/2023',
    collection_date: '2023-09-16',
  },
  {
    tag: 'PBE-2472A-01-5S',
    technique: 'VIBRATION',
    diagnosis: null,
    status: 'Normal',
    observation:
      'Equipamento em condição normal em relação a vibração.\r\nEquipment in normal condition with respect to vibration level.',
    month: 'Sep/2023',
    collection_date: '2023-09-18',
  },
  {
    tag: 'PBE-2472A-01-4S',
    technique: 'VIBRATION',
    diagnosis: null,
    status: 'Normal',
    observation:
      'Equipamento em condição normal em relação a vibração.\r\nEquipment in normal condition with respect to vibration level.',
    month: 'Agost/2023',
    collection_date: '2023-08-18',
  },
];
